import React, {useEffect} from 'react'
import Navbar from '../Navbar'
import Footer from '../footer'
import Products from './Products'
import BackToTop from '../BackToTop'

const ProductPage = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, []);
  return (
    <section>
      <Navbar />

      <Products />

      <Footer />

      <BackToTop />
    </section>
  )
}

export default ProductPage